var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form-check" }, [
    _c(
      "input",
      _vm._g(
        _vm._b(
          {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.form[_vm.name],
                expression: "form[name]",
              },
            ],
            staticClass: "form-check-input",
            class: _vm.labelClasses,
            attrs: { type: "checkbox", id: _vm.id },
            domProps: {
              checked: Array.isArray(_vm.form[_vm.name])
                ? _vm._i(_vm.form[_vm.name], null) > -1
                : _vm.form[_vm.name],
            },
            on: {
              change: function ($event) {
                var $$a = _vm.form[_vm.name],
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && _vm.$set(_vm.form, _vm.name, $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      _vm.$set(
                        _vm.form,
                        _vm.name,
                        $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                      )
                  }
                } else {
                  _vm.$set(_vm.form, _vm.name, $$c)
                }
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        ),
        _vm.$listeners
      )
    ),
    _c("label", { staticClass: "form-check-label", attrs: { for: _vm.id } }, [
      _vm._v(" " + _vm._s(_vm.title) + " "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }